import "../stakeholderlayout.css";

export default function Delivery() {
  return (
    <div className="pillar-section">
      <div className="pillar-header">
        <span className="emoji">🔷</span>
        <h2>STEP 3: DELIVERY & COMMUNICATION</h2>
        <span className="subtitle">Institutionalise Change Through Disciplined Execution</span>
      </div>

      <div className="pillar-content">
        <h3>Purpose</h3>
        <p>
          To translate strategy into operational reality through structured implementation, capacity
          building, and alignment across stakeholders.
        </p>

        <h3>Why This Step Matters</h3>
        <p>
          Without disciplined execution and communication, even the best strategies remain
          documents rather than institutional change.
        </p>

        <h3>What We Implement</h3>
        <ul>
          <li>Standard operating procedures (SOPs)</li>
          <li>Training and capacity building</li>
          <li>Communication frameworks</li>
          <li>Monitoring dashboards</li>
          <li>Alignment protocols</li>
        </ul>

        <h3>Execution Principles</h3>
        <ul>
          <li>Process discipline</li>
          <li>Stakeholder alignment</li>
          <li>Transparent communication</li>
          <li>Continuous monitoring</li>
        </ul>

        <h3>Outputs</h3>
        <ul>
          <li>Implemented systems</li>
          <li>SOPs and protocols</li>
          <li>Training modules</li>
          <li>Monitoring dashboards</li>
        </ul>

        <div className="cta">
          <a href="/approach/delivery-communication" className="learn-more">
            Click → Deep Page
            <span className="arrow">👉</span>
          </a>
        </div>
      </div>
    </div>
  );
}